import { CheckinOrder, CheckoutOrderFragment } from '@websky/graphql';

export const getUnpaidGdsServicesCountByRfisc = (
	order: CheckoutOrderFragment | CheckinOrder,
	rfisc = 'RG1'
): number => {
	let count = 0;

	for (const traveller of order.travellers) {
		if (!traveller.services?.gdsServices?.services) {
			continue;
		}

		for (const service of traveller.services.gdsServices.services) {
			const aviaOrderService = order.additionalServices.gdsServices.services.find(
				additionalService => service.serviceId === additionalService.id && additionalService.rfisc === rfisc
			);

			if (!aviaOrderService) {
				continue;
			}

			count += service.count - service.confirmedCount;
		}
	}

	return count;
};
